// extracted by mini-css-extract-plugin
export var container = "ProudOfSection-module--container--dPa4e";
export var linkContainer = "ProudOfSection-module--linkContainer--oCZwC";